function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.2228 10.3594L18.2814 16.3008C15.7127 18.8695 11.8343 18.4357 10.0273 16.6277C9.47984 16.0796 9.629 15.0439 10.3595 14.315C10.9858 13.6876 11.6693 13.4634 12.669 13.985C13.6687 14.5076 14.8579 14.442 15.6408 13.6602L21.5822 7.71875C22.492 6.80787 22.492 5.32777 21.5822 4.41797C20.6723 3.50709 19.1912 3.50709 18.2814 4.41797L15.0959 7.60236C14.0993 7.09665 12.9334 6.81315 11.7464 6.81315C11.3222 6.81315 10.9043 6.85547 10.4928 6.92426L15.6408 1.77734C18.0105 -0.592448 21.853 -0.592448 24.2228 1.77734C26.5926 4.14714 26.5926 7.98958 24.2228 10.3594Z",
  fill: "#EFEFEF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.9246 19.5138C12.7376 19.5138 11.5718 19.2313 10.5752 18.7256L7.71875 21.5821C6.80841 22.4919 5.32831 22.4919 4.41797 21.5821C3.50763 20.6722 3.50763 19.1911 4.41797 18.2813L10.0314 12.6678C10.8132 11.886 12.0023 11.8194 13.0021 12.343C14.0019 12.8646 14.6853 12.6404 15.3126 12.013C16.0426 11.2819 16.1918 10.2473 15.6448 9.70134C13.8368 7.89224 9.95841 7.4585 7.39016 10.0272L1.77734 15.6406C-0.592448 18.0094 -0.592448 21.8529 1.77734 24.2227C4.14714 26.5925 7.98958 26.5925 10.3594 24.2227L15.1783 19.4027C14.7668 19.4715 14.35 19.5138 13.9246 19.5138Z",
  fill: "#EFEFEF"
});

var SvgLinkIcon = function SvgLinkIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link-icon.3b0ab845.svg";
export { ForwardRef as ReactComponent };